import {Component, Injector, OnInit} from '@angular/core';
import {AbstractListOrmComponent} from "../../AbstractListOrmComponent";
import LocalDataSource from "../../../../data-sources/LocalDataSource";
import {Local} from "../../../../domain/Local";
import {TableLazyLoadEvent} from "primeng/table";
import {LocalService} from "../../../../services/LocalService";
import {FaunaDataSource} from "../../../../services/persist/FaunaDataSource";
import {Equal, IsNull, Not, Or} from "typeorm";

@Component({
  selector: 'app-list-local',
  templateUrl: './list-local.component.html',
  styleUrls: ['./list-local.component.scss'],
})
export class ListLocalComponent extends AbstractListOrmComponent<Local>{
  agenciavel = true
  nos: any[] = []
  select = ['id','nome','biomas','tipo']

  constructor(injector: Injector, ds: FaunaDataSource) {
    super(injector,  ds.getRepository(Local))
  }

  override async load(event: TableLazyLoadEvent): Promise<Local[]>{
    this.event = event
    //ajustes por causa da tree table
    // const filters = {}
    // Object.getOwnPropertyNames(event.filters).forEach(nome => {
    //   // @ts-ignore
    //   filters[nome] = [event.filters[nome] as FilterMetadata]
    // })
    // event.filters = filters
    // event.filters['pai'] = [{value: 'qualquer valor aki', operator: 'and', matchMode: 'isnull'}]
    // const locais = await this.load(event)
    // return locais

    const order = {}
    if(event.sortField)
      order[event.sortField as string]= event.sortOrder
    else
      order['nome'] = 'asc'
    const trees = await this.repo.find({
      relations: ["biomas", "locais.locais.locais.locais.locais.locais.locais"],
      where: {
        pai: IsNull(),
        agencia_sigla: localStorage.getItem("agencia"),
        excluido: Or( Equal(false), IsNull())
      },
      order: order
    })
    // this.orderBy(event, qb)
    this.entidades = trees
    this.total = trees.length
    this.nos = new LocalService().getNos(this.entidades, true)
    return trees
  }

}
